<template>
  <div>
    <div class="modal"
         :class="{ show: showModal }"
         v-show="showModal"
         v-bind:style="{
           display: 'block',
           zIndex: nested ? 1100 : 1050
         }"
         @click="close"
    >
      <div class="modal-dialog"
           @click.stop
           role="document"
           v-bind:class="[ modalClass ]"
      >
        <slot></slot>
      </div>
    </div>
    <div class="modal-backdrop fade show" v-show="showModal"></div>
  </div>
</template>

<script>
  export default {
    name: 'Modal',
    props: {
      showModal: Boolean,
      modalClass: String,
      nested: Boolean
    },
    methods: {
      toggleBodyClass(addRemoveClass, className) {
        const el = document.body

        if (addRemoveClass === 'addClass') {
          const offsetY = window.pageYOffset
          document.body.style.top = `${-offsetY}px`
          el.classList.add(className)
        } else {
          const offsetY = Math.abs(parseInt(document.body.style.top || 0, 10))
          el.classList.remove(className)
          document.body.style.removeProperty('top')
          window.scrollTo(0, offsetY || 0)
        }
      },
      close() {
        this.$emit('update:showModal', false)
      }
    },
    mounted() {
      const content = this.$el.getElementsByClassName('modal')[0]
      const modalsContainer = document.getElementById('modals-container')
      content.parentNode.removeChild(content)
      modalsContainer.appendChild(content)
    },
    watch: {
      showModal: function () {
        if (this.showModal) {
          this.toggleBodyClass('addClass', 'modal-open')
        } else {
          this.toggleBodyClass('removeClass', 'modal-open')
        }
      }
    }
  }
</script>
